import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { useTranslation } from "react-i18next";
import classes from "./Activities.module.css";
import styles from "./activityCards.module.css";
import { testUrl } from "../BaseData";
import Pagination from "@mui/material/Pagination";

const OquvJarayoni = () => {
  const navigate = useNavigate();
  const { t, i18n } = useTranslation();
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [category, setCategory] = useState(null);
  const [activityTypes, setActivityTypes] = useState([]);
  const [news, setNews] = useState([]);
  const [pageApi, setPageApi] = useState(1);
  const itemsPerPage = 9;

  // Function to sort sidebar items to match navbar order
  const sortSidebarItems = (items) => {
    const navbarOrder = [
      'oquv-jarayoni',
      'talim-jarayoni-meyoriy-hujjatlari',
      'video-maruzalar',
      'amaliyot-shartnomalari',
      'oquv-rejalari',
      'nazorat-sinovlari',
      'bmi-mavzular'
    ];

    const sortSidebarItems = (items) => {
      const navbarOrder = [
        'ilmiy-jarayonlar',
        'ilmiy-kengash',
        'ilmiy-konferensiyalar',
        'journal',
        'ilmiy-maktablar',
        'green-renessans',
        'oquv-va-labaratoriya-bazalari',
        'axborotlashtirish-jarayonlari',
        'yosh-akademiklar',
        'avtorefereat-dissertatsiya'
      ];

      return items.sort((a, b) => {
        const aIndex = navbarOrder.indexOf(a.short_name);
        const bIndex = navbarOrder.indexOf(b.short_name);

        // If both items are in the navbar order, sort by their position
        if (aIndex !== -1 && bIndex !== -1) {
          return aIndex - bIndex;
        }

        // If only one item is in the navbar order, prioritize it
        if (aIndex !== -1) return -1;
        if (bIndex !== -1) return 1;

        // If neither item is in the navbar order, keep original order
        return 0;
      });
    };

    return items.sort((a, b) => {
      const aIndex = navbarOrder.indexOf(a.short_name);
      const bIndex = navbarOrder.indexOf(b.short_name);

      // If both items are in the navbar order, sort by their position
      if (aIndex !== -1 && bIndex !== -1) {
        return aIndex - bIndex;
      }

      // If only one item is in the navbar order, prioritize it
      if (aIndex !== -1) return -1;
      if (bIndex !== -1) return 1;

      // If neither item is in the navbar order, keep original order
      return 0;
    });
  };

  useEffect(() => {
    setLoading(true);
    setError(null);

    const fetchData = axios.get(testUrl + "/api/baseactivity/oquv-faoliyat/oquv-jarayoni");

    Promise.all([fetchData])
      .then(([response]) => {
        const data = response.data;
        if (data) {
          setCategory(data.category || null);
          const sortedItems = sortSidebarItems(data.activities_types || []);
          setActivityTypes(sortedItems);
          setNews(data.activities_post || []);
        }
      })
      .catch(() => setError("Ma'lumotlarni yuklashda xatolik"))
      .finally(() => setLoading(false));
  }, [i18n.language]);

  const indexOfLastItem = pageApi * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentNews = news.slice(indexOfFirstItem, indexOfLastItem);

  if (loading) return <div>Yuklanmoqda...</div>;
  if (error) return <div>{error}</div>;

  const currentShort = "oquv-jarayoni";

  return (
    <div className={classes["mainContainer"]}>
      <div data-aos="fade-up" className={classes["container"]}>
        <h1 className={classes["page-title"]}>{t("oquv_jarayoni_title")}</h1>
        <div className={styles.facultyGrid}>
          {currentNews.filter(Boolean).map((item) => (
            <div
              key={item.id}
              className={styles.activityCard}
              onClick={() => navigate(`/activity/${item.id}`)}
            >
              <img src={item.image} alt=" " className={styles.activityImage} />
              <div className={styles.activityInfo}>
                <h3>{item[`name_${i18n.language}`] || item.name_uz}</h3>
              </div>
            </div>
          ))}
        </div>
        <div style={{ display: 'flex', justifyContent: 'center', margin: '24px 0' }}>
          <Pagination
            onChange={(e, value) => setPageApi(value)}
            count={Math.ceil(news.length / itemsPerPage)}
            page={pageApi}
            variant="outlined"
            shape="rounded"
          />
        </div>
      </div>
      <div className={classes.sidebar}>
        <h3>{category ? category[`name_${i18n.language}`] : t("categories")}</h3>
        <ul>
          {activityTypes.map((cat) => (
            <li
              key={cat.id}
              className={cat.short_name === currentShort ? classes.active : ""}
              onClick={() => navigate(`/activity/${category.short_name}/${cat.short_name}`)}
            >
              {cat[`name_${i18n.language}`]}
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
};

export default OquvJarayoni; 